/**
 * Created by Muiz on 19/10/2017.
 */
import Vue from 'vue'
import Notify from 'vue-notification'
import velocity from 'velocity-animate'
import iziToast from 'izitoast'// https://github.com/dolce/iziToast
import 'izitoast/dist/css/iziToast.min.css'

Vue.use(Notify, { velocity })

/* export default {
  warning: function (title, text) {
    Vue.prototype.$notify({
      animationType: 'velocity',
      type: 'warn',
      title: title,
      text: text,
      position: 'bottom center'
    })
  },
  success: function (title, text) {
    Vue.prototype.$notify({
      animationType: 'velocity',
      type: 'succ',
      title: title,
      text: text,
      position: 'top center'
    })
  },
  error: function (title, text) {
    Vue.prototype.$notify({
      animationType: 'velocity',
      type: 'error',
      title: title,
      text: text,
      position: 'bottom center'
    })
  }
} */

export default {
  warning: function (title, text) {
    iziToast['warning']({
      theme: 'light',
      position: 'topCenter',
      progressBarColor: 'rgb(0, 255, 184)',
      title: title,
      message: text
    })
  },
  success: function (title, text) {
    iziToast['success']({
      theme: 'light',
      position: 'topCenter',
      progressBarColor: 'rgb(0, 255, 184)',
      title: title,
      message: text
    })
  },
  error: function (title, text) {
    iziToast['error']({
      theme: 'light',
      position: 'topCenter',
      progressBarColor: 'rgb(0, 255, 184)',
      title: title,
      message: text
    })
  }
}



// WEBPACK FOOTER //
// ./src_suopass/mixins/Notify.js